module.exports = __webpack_public_path__ + "static/media/M1-16-Yazaroth-cod115.2cf6a251.png";